import { ItemType } from "antd/es/menu/interface";
import { PermissionString } from "config/UserPermissionsContext/userPermissionsConstants";
import React from "react"; // Import React for JSX
import ConnectSocialsTooltip from "../components/Utility/ConnectSocialsTooltip";

type HasPermissionFn = (
  permission: PermissionString,
  allowSuperUser?: boolean
) => boolean;

export const generateScheduledPostActionItems = (
  canEditPosts: boolean,
  hasPermission: HasPermissionFn,
  connectedSocialsLength: number,
  autoScheduledIndex: number | undefined,
  autoScheduledTimes: string[] | undefined,
  customTimeMenuItem: ItemType,
  isMarkyRealm: boolean
): ItemType[] => {
  const items: ItemType[] = [];

  if (canEditPosts) {
    items.push({
      key: "edit-post",
      label: "Edit Post",
    });
  }

  if (hasPermission("post_status_draft_write")) {
    items.push({ key: "save-post", label: "Move to Drafts" });
  }

  if (hasPermission("post_status_publish_write")) {
    items.push({
      key: "publish-post",
      label: React.createElement(ConnectSocialsTooltip, null, "Publish Now"),
      disabled: !connectedSocialsLength,
    });
  }

  if (autoScheduledIndex !== undefined && autoScheduledTimes) {
    items.push(
      ...(hasPermission("post_status_schedule_write")
        ? [
            {
              key: "move-to-top",
              label: "Move to top (post next)",
              disabled: autoScheduledIndex === 0,
            },
            {
              key: "move-to-bottom",
              label: "Move to bottom (post last)",
              disabled: autoScheduledIndex === autoScheduledTimes.length - 1,
            },
            customTimeMenuItem,
          ]
        : [{ key: "move-to-queue", label: "Move to Queue" }])
    );
  }

  if (isMarkyRealm) {
    items.push({ key: "duplicate-post", label: "Duplicate Post" });
  }

  if (hasPermission("post_status_trash_write")) {
    items.push({ key: "discard-post", label: "Trash" });
  }

  return items;
};
